export default "<div>\n    <div ng-if=\"showFeature\">\n        <ng-transclude></ng-transclude>\n    </div>\n</div>";